const pulseAdChoicesEnabled = true;

const shouldRestrictAdDerivedIdentifiers = (consentToAds: boolean) =>
  pulseAdChoicesEnabled && !consentToAds;

export { pulseAdChoicesEnabled, shouldRestrictAdDerivedIdentifiers };
